<template>
    <div class="alyssa-header-container">
        <div class="alyssa-logo-container">
            <a href="/" class="alyssa-logo-link">
                <img class="nav-logo" :src="settings.logoUrl">
            </a>
        </div>
        <div class="back-home">
            <a href="https://aglassofgoldwater.com">BACK TO HOMEPAGE</a>
        </div>
    </div>
</template>

<script>
    import settings from '@/settings'
    export default {
        data() {
            return {
                
            }
        },
        computed: {
            settings: function () {
                return settings;
            }
        },
        methods: {
            
        }
    }
</script>